var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRomania(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagRomania_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagRomania_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagRomania_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagRomania_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagRomania_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFD928",
    d: "M3 47h41V0H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F00AF",
    d: "M3 47h14V0H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D00524",
    d: "M31 47h14V0H31z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0idGEya3RtbW43YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSI3azUzYjVrOHNiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3RhMmt0bW1uN2EiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiN0YTJrdG1tbjdhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjN2s1M2I1azhzYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0VGRDkyOCIgZD0iTTAgNDdMNDEgNDcgNDEgMCAwIDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMxRjAwQUYiIGQ9Ik0wIDQ3TDE0IDQ3IDE0IDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRDAwNTI0IiBkPSJNMjggNDdMNDIgNDcgNDIgMCAyOCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMykiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlagRomania as ReactComponent };